<template>
  <div>
    <div class="nav-vertical">
      <ul class="nav nav-tabs nav-left" role="tablist">
        <li class="nav-item">
          <a
            class="nav-link active"
            v-bind:href="'#t1' + rowData.municipio_id + ''"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Detalhes
              <i class="fa fa-plus"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t2' + rowData.municipio_id + ''"
            role="tab"
            data-toggle="tab"
            v-if="rowData.municipio_equivalente.length > 0"
          >
            <span class="nav-link-in">
              Equivalência
              <i class="fa fa-plus"></i>
            </span>
          </a>
        </li>
      </ul>

      <div class="tab-content">
        <div
          role="tabpanel"
          class="tab-pane fade in active show pt-1 border-color-detalhes-grey"
          v-bind:id="'t1' + rowData.municipio_id + ''"
        >
          <table class="table" id="mais">
            <thead>
              <tr>
                <th style="width: 30%">CEP Inicial</th>
                <th style="width: 30%">CEP Final</th>
                <th style="width: 20%">Status</th>
                <th style="width: 20%">Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-for="item in rowData.municipio_cep"
              >
                <td>
                  {{ item.cep_inicial }}
                </td>
                <td>
                  {{ item.cep_final }}
                </td>
                <td>
                  <span
                    class="badge badge-success"
                    v-if="item.status.valor == 1"
                    >{{ item.status.descr }}</span
                  >
                  <span
                    class="badge badge-danger"
                    v-if="item.status.valor == 2"
                    >{{ item.status.descr }}</span
                  >
                </td>
                <td>
                  <a v-if="getPermissionFw('municipio.update.cep')" @click="onEdit(item)" v-b-tooltip title="Editar"
                    ><i class="fa fa-pencil-square-o"></i
                  ></a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t2' + rowData.municipio_id + ''"
          v-if="rowData.municipio_equivalente.length > 0"
        >
          <table class="table" id="mais">
            <thead>
              <tr>
                <th style="width: 30%">Nome da Equivalência</th>
                <th style="width: 20%">Status</th>
                <th style="width: 20%">Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-for="item in rowData.municipio_equivalente"
              >
                <td>
                  {{ item.nome }}
                </td>
                <td>
                  <span
                    class="badge badge-success"
                    v-if="item.status.valor == 1"
                    >{{ item.status.descr }}</span
                  >
                  <span
                    class="badge badge-danger"
                    v-if="item.status.valor == 2"
                    >{{ item.status.descr }}</span
                  >
                </td>
                <td>
                  <a
                    @click="onEditMunEqui(item)"
                    v-if="getPermissionFw('municipio.equivalente.update')"
                    v-b-tooltip
                    title="Editar Equivalência"
                    ><i class="fa fa-pencil-square-o"></i
                  ></a>
                  <a
                    v-if="item.status.valor == 2 && getPermissionFw('municipio.equivalente.status')"
                    @click="onActivateDesactivate(1, item, true)"
                    v-b-tooltip
                    title="Ativar"
                    ><i class="fa fa-thumbs-o-up"></i
                  ></a>
                  <a
                    v-if="item.status.valor == 1 && getPermissionFw('municipio.equivalente.status')"
                    @click="onActivateDesactivate(2, item, true)"
                    v-b-tooltip
                    title="Inativar"
                    ><i class="fa fa-thumbs-o-down"></i
                  ></a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
      </div>
      <!--.tab-content-->
    </div>
  </div>
</template>

  <script>
export default {
  data() {
    return {
      helpForm: new Form({ statusRecord: [], params: [] }),
    };
  },
  props: {
    rowData: {
      type: Object,
      required: true,
    },
    rowIndex: {
      type: Number,
    },
  },
  methods: {
    onEdit(data) {
      this.$parent.$parent.onEditCep(data);
    },
    onEditMunEqui(data) {
      this.$parent.$parent.onEditMunEqui(data);
    },
    onActivateDesactivate(action, data, tipo) {
      // Tipo = true = Checkbox
      if (tipo) {
        this.helpForm.statusRecord = [];
        this.helpForm.statusRecord.push({
          id: data.municipioequi_id,
          status: action,
        });
      } else {
        this.helpForm.statusRecord = [];
        this.$refs.vuetable.selectedTo.forEach((obj) => {
          this.helpForm.statusRecord.push({ id: obj, status: action });
        });
      }
      this.$parent.$parent.onActivateDesactivateEqui(this.helpForm);
    },
  },
};
</script>
